import { FloatButton, Popover, Tooltip } from "antd";
import { FieldTimeOutlined, ScanOutlined, ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { DefaultZoomSettingsIcon, NorthIcon, View3dIcon } from "../core/customIcons";
import './singleLayerCommand.css'
import { useEffect, useState } from "react";
import { SingleLayerTime } from "./SingleLayerTime";
import { SplitViewLayerTime } from "../splitView/SplitViewLayerTime";
import { useNavigate } from "react-router-dom";


export function SingleLayerCommand({
    id,
    idTwo,
    viewState,
    setViewState,
    isView3d,
    setIsView3d,
    isSplitView,
    setIsSplitView,
    isTime,
    dataTime,
    timeSelectedIdx,
    setTimeSelectedIdx,
    isTimeTwo,
    dataTimeTwo,
    timeTwoSelectedIdx,
    setTimeTwoSelectedIdx,
    isH3
}) {
    const navigate = useNavigate();
    const bottomPosition = 40
    const leftPosition = 40
    const widthElement = 50
    const [isTimeView, setIsTimeView] = useState(false)

    function changeView() {
        setIsView3d(!isView3d)
    }

    function toggleSplitView() {
        setIsSplitView(!isSplitView)
        if (isSplitView) {
            navigate(`/layer/${id}`);
        } else {
            navigate(`/layer/${id}/${id}`);
        }
    }

    useEffect(() => {
        if (isSplitView) {
            setIsTimeView(isTime || isTimeTwo)
        } else {
            setIsTimeView(isTime)
        }
    }, [id, idTwo, isTime, isTimeTwo]);

    function setToNorth() {
        setViewState({
            ...viewState,
            bearing: 0,
            transitionDuration: 400,
        })
    }

    function zoomIn() {
        setViewState({
            ...viewState,
            zoom: (viewState.zoom + 1) > viewState.maxZoom ? viewState.maxZoom : viewState.zoom + 1,
            transitionDuration: 200,
        })
    }

    function zoomOut() {
        setViewState({
            ...viewState,
            zoom: (viewState.zoom - 1) < viewState.minZoom ? viewState.minZoom : viewState.zoom - 1,
            transitionDuration: 200,
        })
    }

    function setToDefault() {
        setViewState({
            ...viewState,
            longitude: 105.64,
            latitude: -1.48,
            zoom: 4.6,
            pitch: 0,
            maxZoom: 17,
            minZoom: 4.6,
            bearing: 0,
            transitionDuration: 400,
        })
    }

    return (
        <>
            <Tooltip placement="topRight"
                title={<div>Set north direction</div>}>
                <FloatButton
                    onClick={setToNorth}
                    icon={<NorthIcon />}
                    shape="square"
                    style={{
                        left: leftPosition,
                        bottom: bottomPosition + widthElement * 3
                    }}
                />
            </Tooltip>

            <Tooltip placement="right"
                title={<div>Zoom in</div>}>
                <FloatButton
                    onClick={zoomIn}
                    icon={<ZoomInOutlined />}
                    shape="square"
                    style={{
                        left: leftPosition,
                        bottom: bottomPosition + widthElement * 2
                    }}
                />
            </Tooltip>

            <Tooltip placement="right"
                title={<div>Zoom out</div>}>
                <FloatButton
                    onClick={zoomOut}
                    icon={<ZoomOutOutlined />}
                    shape="square"
                    style={{
                        left: leftPosition,
                        bottom: bottomPosition + widthElement
                    }}
                />
            </Tooltip>

            <Tooltip placement="right"
                title={<div>Reset default</div>}>
                <FloatButton
                    onClick={setToDefault}
                    icon={<DefaultZoomSettingsIcon />}
                    shape="square"
                    style={{
                        left: leftPosition,
                        bottom: bottomPosition
                    }}
                />
            </Tooltip>

            {!isH3 && <Tooltip placement="topRight"
                title={isView3d ? <div>Switch to 2D view</div> : <div>Switch to 3D view</div>}>
                <FloatButton
                    onClick={changeView}
                    icon={<View3dIcon />}
                    type={isView3d === true ? 'primary' : 'default'}
                    shape="square"
                    style={{
                        left: leftPosition + widthElement * 2,
                        bottom: bottomPosition
                    }}
                />
            </Tooltip>
            }

            {!isH3 && <Tooltip placement="topRight" title={<div>Side by side</div>}>
                <FloatButton
                    onClick={toggleSplitView}
                    icon={<ScanOutlined rotate={90} />}
                    type={isSplitView === true ? 'primary' : 'default'}
                    shape="square"
                    style={{
                        left: leftPosition + widthElement * 3,
                        bottom: bottomPosition
                    }}

                />
            </Tooltip>
            }

            {!isSplitView && isTime && <Popover
                content={<SingleLayerTime
                    id={id}
                    dataTime={dataTime}
                    timeSelectedIdx={timeSelectedIdx}
                    setTimeSelectedIdx={setTimeSelectedIdx}
                ></SingleLayerTime>}
                title=""
                trigger="click"
                placement="rightBottom"
                open={isTimeView}
            >
                <Tooltip placement="topRight" title={<div>Show time series filter</div>}><FloatButton
                    onClick={() => setIsTimeView(!isTimeView)}
                    icon={<FieldTimeOutlined />}
                    shape="square"
                    type={isTimeView === true ? 'primary' : 'default'}
                    style={{
                        left: leftPosition + widthElement * 4,
                        bottom: bottomPosition
                    }}
                /></Tooltip>
            </Popover>}

            {isSplitView && (isTime || isTimeTwo) && <Popover
                content={<SplitViewLayerTime
                    id={id}
                    isTime={isTime}
                    dataTime={dataTime}
                    timeSelectedIdx={timeSelectedIdx}
                    setTimeSelectedIdx={setTimeSelectedIdx}
                    idTwo={idTwo}
                    isTimeTwo={isTimeTwo}
                    dataTimeTwo={dataTimeTwo}
                    timeTwoSelectedIdx={timeTwoSelectedIdx}
                    setTimeTwoSelectedIdx={setTimeTwoSelectedIdx}
                ></SplitViewLayerTime>}
                title=""
                trigger="click"
                placement="rightBottom"
                open={isTimeView}
            >
                <Tooltip placement="topRight" title={<div>Show time series filter</div>}><FloatButton
                    onClick={() => setIsTimeView(!isTimeView)}
                    icon={<FieldTimeOutlined />}
                    shape="square"
                    type={isTimeView === true ? 'primary' : 'default'}
                    style={{
                        left: leftPosition + widthElement * 4,
                        bottom: bottomPosition
                    }}
                /></Tooltip>
            </Popover>}


        </>
    )
}